"use strict";

define('app/study/list/study.list.controller',['rs/abstract.content.controller', 'e3-table', 'e3-common', 'app/study/list/study.list.view', 'rs/models/group', 'rs/models/study', 'rs/models/task', 'rs/models/assignment.builder', 'rs/paginate', 'rs/services/workflow.service', 'evisions/validation', 'rs/helper', 'rs/deparam'], function (AbstractListController, E3Table, E3Common, StudyListView, Group, Study, Task, AssignmentBuilder, Paginate, WorkflowService, validation, helper, deparam) {
  var StudyListController = AbstractListController.extend({
    name: 'Study List',
    contentName: 'study-list-content abstract-content fixed-header off-white',
    studyColumns: [{
      name: 'label',
      displayName: 'IRB Number',
      type: 'String',
      sortName: 'label',
      width: '15%'
    }, {
      name: 'title',
      sortName: 'title',
      displayName: 'Title',
      type: 'String',
      width: '25%'
    }, {
      name: 'sponsors',
      sortName: 'sponsors',
      displayName: 'Sponsor',
      type: 'String',
      width: '20%'
    }, {
      name: 'principalInvestigator',
      sortName: 'principalInvestigator',
      displayName: 'PI',
      type: 'String',
      width: '15%'
    }, {
      name: 'expirationDate',
      sortName: 'expirationDate',
      displayName: 'Expiration Date',
      type: 'Date',
      width: '12%'
    }, {
      name: 'status',
      sortName: 'status',
      displayName: 'Status',
      type: 'String',
      width: '13%'
    }],
    taskColumns: [{
      name: 'studyLabel',
      sortName: 'studyLabel',
      displayName: 'IRB Number',
      type: 'String',
      width: '15%'
    }, {
      name: 'studyTitle',
      sortName: 'studyTitle',
      displayName: 'Study Title',
      type: 'String',
      width: '25%'
    }, {
      name: 'templateType',
      sortName: 'templateType',
      displayName: 'Type',
      type: 'String',
      width: '10%'
    }, {
      name: 'assignmentDisplayName',
      sortName: 'assignment',
      displayName: 'Assignment',
      type: 'string',
      width: '15%'
    }, {
      name: 'taskAction',
      sortName: 'status',
      displayName: 'Task',
      type: 'String',
      width: '20%'
    }, {
      name: 'taskBeginDate',
      sortName: 'taskBeginDate',
      displayName: 'Date Tasked',
      type: 'Date',
      width: '15%'
    }],
    properties: ['allPaginate', 'assignmentTypes', 'filterText', 'inboxPaginate', 'selectedTab', 'tableController', 'userPaginate'],
    pageCountOptions: [25, 50, 100],
    validators: {
      'studyName': [validation.empty('You must enter a study title'), validation.checkLength(3, 600)]
    },
    propertyFilters: [{
      name: 'Status',
      field: 'status',
      options: 'workflowStates'
    }, {
      name: 'Assignment',
      field: 'assignment',
      options: 'assignmentTypes'
    }, {
      name: 'Status',
      field: 'status',
      options: 'statuses'
    }],
    statuses: ['Approved', 'Closed', 'Disapproved', 'Expired', 'Requires Changes', 'Submitted', 'Suspended', 'Under Review', 'Unsubmitted', 'Withdrawn'],
    workflowStates: ['Assign Analyst', 'Certify Submission', 'In Draft', 'Under Expedited Review', 'Awaiting Organization Approval', 'Under Review By Board', 'Under Full Board Review', 'Under Review By Analyst'],
    filterText: '',
    view: StudyListView,
    initialize: function initialize() {
      this._super.apply(this, arguments);
      this.setUserPaginate(new Paginate({
        sort: 'label'
      }));
      this.setAllPaginate(new Paginate({
        sort: 'label'
      }));
      this.setInboxPaginate(new Paginate({
        sort: 'taskBeginDate',
        sortDirection: 'desc'
      }));
      this.pageCountOptions = new Backbone.Collection(_.map(this.pageCountOptions, function (count) {
        return {
          count: count,
          selected: false
        };
      }));
      this.listenTo(this.pageCountOptions, 'change:selected', function (model) {
        if (model.get('selected') && this.getCurrentPaginate()) {
          this.getCurrentPaginate().setSize(model.get('count')).resetPage();
        }
      });
      this.setTableController(new E3Table.Controller({
        delegate: this,
        columns: this.getColumns(),
        theme: 'rs',
        remoteSort: true,
        remoteFilter: true
      }));
      this.listenTo(this.getTableController(), 'change:sort', this.tableSortDidChange);
      this.sync('selectedTab');
      this.sync('filter');
      this.setAssignmentTypes(AssignmentBuilder.getStudyAssignmentDisplayTypes());
      this.registerTableController(this.getTableController());
    },
    didResetPage: function didResetPage() {
      this.getView().resetScroll();
    },
    tableSortDidChange: function tableSortDidChange() {
      var table = this.getTableController(),
        sort = table.getSort(),
        direction = sort ? sort.direction : 1,
        paginate = this.getCurrentPaginate(),
        column = sort ? sort.column : null;
      switch (direction) {
        case table.SORT_ASC:
          paginate.setSortDirection('asc');
          break;
        case table.SORT_DESC:
          paginate.setSortDirection('desc');
          break;
        default:
          paginate.setSortDirection(null);
      }
      if (column && column.name) {
        paginate.setSort(column.original.sortName || column.name);
      } else {
        paginate.setSort(null);
      }
    },
    viewIsReady: function viewIsReady() {
      this.getView().setupScrolling();
      this._super();
    },
    viewIsAvailable: function viewIsAvailable() {
      this.getTableController().setup(this.getView().getTableElement());
      this._super();
    },
    setupTabs: function setupTabs(initialTabIndex, groups, paginateParams) {
      var boards = _.filter(groups, function (group) {
          return group.tag == 'IRB_BOARD';
        }),
        taskSortOptions = _.pluck(this.taskColumns, 'sortName'),
        studySortOptions = _.pluck(this.studyColumns, 'sortName');
      this.tabs = [{
        displayName: 'My Tasks',
        name: 'inbox',
        columns: 'taskColumns'
      }, {
        displayName: 'My Studies',
        name: 'mine',
        columns: 'studyColumns'
      }];
      if (this.checkPermission('IRB_VIEW_ALL_STUDIES')) {
        this.tabs.push({
          displayName: 'All Studies',
          name: 'all',
          columns: 'studyColumns'
        });
      }
      initialTabIndex = parseInt(initialTabIndex || 0);
      if (initialTabIndex >= this.tabs.length || initialTabIndex < 0) {
        initialTabIndex = 0;
        paginateParams = {};
      }
      if (initialTabIndex == 0) {
        paginateParams.sort = taskSortOptions.indexOf(paginateParams.sort) > -1 ? paginateParams.sort : taskSortOptions[0];
      } else {
        paginateParams.sort = studySortOptions.indexOf(paginateParams.sort) > -1 ? paginateParams.sort : studySortOptions[0];
      }
      this.setSelectedTab(this.tabs[initialTabIndex], {
        trigger: false
      });
      this.getCurrentPaginate().importProperties(paginateParams);
      this.setSelectedTab(this.tabs[initialTabIndex], {
        trigger: true
      });
    },
    start: function start(initialTabIndex, paramString) {
      return Group.requestGroupsByCurrentUser().bind(this).then(function (groups) {
        this.setupTabs(initialTabIndex, groups, deparam(paramString || ''));
        this.render();
        this.getView().toggleFilters(initialTabIndex);
        this.getTableController().start();
      });
    },
    setTabByIndex: function setTabByIndex(index) {
      if (this.getCurrentPaginate()) {
        this.stopListening(this.getCurrentPaginate());
      }
      this.setSelectedTab(this.tabs[index]);
    },
    getColumns: function getColumns() {
      var tab = this.getSelectedTab() || {};
      return this[tab.columns] || [];
    },
    requestFilterText: function requestFilterText(text) {
      this.getCurrentPaginate().setQuery(text);
      this.getCurrentPaginate().resetPage();
    },
    refreshColumnsPropertyOnView: function refreshColumnsPropertyOnView() {
      this.getTableController().setColumns(this.getColumns());
    },
    getTemplateProperties: function getTemplateProperties() {
      return {
        propertyFilters: this.propertyFilters,
        tabs: this.tabs,
        help: this.getHelpLink('HH_11'),
        searchQuery: this.getCurrentPaginate() ? this.getCurrentPaginate().getQuery() : '',
        newStudy: {
          help: this.getHelpLink('HH_10')
        }
      };
    },
    tableItemWasSelected: function tableItemWasSelected(item) {
      var model = item.item;
      if (this.getSelectedTab().name == "inbox") {
        var psuedoModel = {
          id: model.studyId,
          documentId: model.documentId
        };
        this.getAppController().navigateStudy(psuedoModel, {
          trigger: true
        });
      } else {
        this.getAppController().navigateStudy(model, {
          trigger: true
        });
      }
    },
    getData: function getData() {
      var tabName = this.getSelectedTab().name,
        paginate = this.getCurrentPaginate();
      return Promise.attempt(function () {
        switch (tabName) {
          case 'mine':
            return Study.requestUserStudies(paginate);
            break;
          case 'all':
            return Study.requestAllStudies(paginate);
          case 'inbox':
            return WorkflowService.requestTasks(paginate);
            break;
        }
      });
    },
    getCurrentPaginate: function getCurrentPaginate() {
      var tabName = this.getSelectedTab().name;
      switch (tabName) {
        case 'mine':
          return this.getUserPaginate();
          break;
        case 'all':
          return this.getAllPaginate();
          break;
        case 'inbox':
          return this.getInboxPaginate();
          break;
        default:
          return this.getInboxPaginate();
          break;
      }
    },
    refreshSelectedTabPropertyOnView: function refreshSelectedTabPropertyOnView() {
      this.getView().selectTabByName(this.getSelectedTab().name);
    },
    selectedTabDidChange: function selectedTabDidChange() {
      var paginate = this.getCurrentPaginate(),
        table = this.getTableController(),
        refreshTable = _.bind(table.refresh, table),
        refreshQueryInView = _.bind(this.refreshQueryInView, this),
        refreshPageCount = _.bind(this.refreshPageCount, this),
        refreshRoute = _.bind(this.refreshStudyRoute, this),
        debounceAmount = 20;
      this.listenTo(paginate, 'change:sort change:sortDirection change:page change:query change:filters change:size', _.debounce(refreshTable, debounceAmount));
      this.listenTo(paginate, 'change:totalPages change:page change:size', this.refreshPaginationView);
      this.listenTo(paginate, 'change:totalPages', this.refreshPageCountVisibility);
      this.listenTo(paginate, 'change:page', this.didResetPage);
      this.listenTo(paginate, 'change:query', _.debounce(refreshQueryInView, debounceAmount));
      this.listenTo(paginate, 'change:page change:sort change:sortDirection change:filters change:query change:size', _.debounce(refreshRoute, debounceAmount));
      this.listenTo(paginate, 'change:size', _.debounce(refreshPageCount, debounceAmount));
      table.setColumns(this.getColumns());
      var column = _.findWhere(this.getColumns(), {
        sortName: paginate.getSort()
      });
      if (column) {
        table.setSortByName(column.name, paginate.getSortDirection() == 'asc' ? table.SORT_ASC : table.SORT_DESC);
      }
      table.refresh();
      this.refreshPaginationView();
      refreshRoute();
      refreshQueryInView();
      refreshPageCount();
      this.refreshPageCountVisibility();
    },
    refreshPageCountVisibility: function refreshPageCountVisibility() {
      var paginate = this.getCurrentPaginate();
      if (paginate.getTotalPages() <= 1 && this.pageCountOptions.first().get('selected')) {
        this.getView().hidePageSize();
      } else {
        this.getView().showPageSize();
      }
    },
    refreshPageCount: function refreshPageCount() {
      var paginate = this.getCurrentPaginate(),
        count = this.pageCountOptions.findWhere({
          count: Number(paginate.getSize())
        });
      this.pageCountOptions.each(function (count) {
        count.set('selected', false);
      });
      if (count) {
        count.set('selected', true);
      }
    },
    refreshQueryInView: function refreshQueryInView() {
      this.getView().setQueryString(this.getCurrentPaginate().getQuery());
    },
    refreshStudyRoute: function refreshStudyRoute() {
      this.getAppController().navigateStudyList(null, _.indexOf(this.tabs, this.getSelectedTab()), this.getCurrentPaginate());
    },
    refreshPaginationView: function refreshPaginationView() {
      var paginate = this.getCurrentPaginate(),
        pages = [];
      for (var i = 0, len = paginate.getTotalPages(); i < len; i++) {
        pages.push({
          label: String(i + 1),
          page: i + 1,
          active: i + 1 === paginate.getPage()
        });
      }
      this.getView().renderPages(pages);
    },
    createStudy: function createStudy(definition) {
      return Study.requestCreateStudy(definition).bind(this).then(function (study) {
        this.getAppController().navigateStudy(study, {
          trigger: true
        });
      }).lastly(this.showLoading());
    },
    requestCreateStudy: function requestCreateStudy(title) {
      if (this.validate()) {
        this.createStudy({
          'title': title
        });
      }
    },
    closeCreateStudy: function closeCreateStudy() {
      var view = this.getView();
      view.closeCreateStudy();
      view.emptyClearStudyData();
    },
    propertyFilterDidChange: function propertyFilterDidChange(index, val, checked) {
      var filter = this.propertyFilters[index],
        paginate = this.getCurrentPaginate(),
        valIndex = null;
      if (checked) {
        paginate.addFilter(filter.field, val);
      } else {
        paginate.removeFilter(filter.field, val);
      }
    }
  });
  return StudyListController;
});

